import { render, staticRenderFns } from "./LayoutsTab.vue?vue&type=template&id=660277f6"
import script from "./LayoutsTab.vue?vue&type=script&lang=js"
export * from "./LayoutsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660277f6')) {
      api.createRecord('660277f6', component.options)
    } else {
      api.reload('660277f6', component.options)
    }
    module.hot.accept("./LayoutsTab.vue?vue&type=template&id=660277f6", function () {
      api.rerender('660277f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutSettingsModal/LayoutsTab.vue"
export default component.exports